import { post } from '@/api/axios';
import { type ApiResponse } from '@/api/core/_models';
import { type AttachmentDto } from '@/app/models/AttachmentDto';
import { type AttachmentUploadOptions } from '@/app/modules/attachments/core/_models';

export const uploadAttachment = (file: File, options: AttachmentUploadOptions): Promise<ApiResponse<AttachmentDto>> => {
  const filename = file.name.length > 80 ? `${file.name.slice(0, 80)}.${file.name.split('.').pop()}` : file.name;
  const formData = new FormData();
  const image = new File([file], filename, { type: file.type });
  formData.append('file', image);
  const temporaryValue = options.temporary.toString();
  const localValue = options.local.toString();
  formData.append('temporary', temporaryValue);
  formData.append('local', localValue);
  return post<AttachmentDto>(options.endpoint, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress,
    signal: options.signal,
  });
};
